"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePassword = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _LoginPasswordStrength = require("../../molecules/LoginPasswordStrength");

var _react = require("react");

var _GeneralButton = require("../../atoms/GeneralButton");

var _LogoImage = require("../../atoms/LogoImage");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _GradientPanel = require("../../atoms/GradientPanel");

var _jsxRuntime = require("react/jsx-runtime");

var ChangePassword = function ChangePassword(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      emptyPassword = _useState2[0],
      setEmptyPassword = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      emptyConfirmPassword = _useState4[0],
      setEmptyConfirmPassword = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      matchPasswords = _useState6[0],
      setMatchPasswords = _useState6[1];

  var validate = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var password, confirmPassword, valid;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              password = document.querySelector("#newPasswordInput").value;
              password.length < 8 ? setEmptyPassword(true) : setEmptyPassword(false);
              confirmPassword = document.querySelector("#confirmPasswordInput").value;
              confirmPassword === "" ? setEmptyConfirmPassword(true) : setEmptyConfirmPassword(false);

              if (password === confirmPassword) {
                setMatchPasswords(true);
              } else {
                setMatchPasswords(false);
              }

              valid = true;

              if (password.length < 8 || confirmPassword === "" || password !== confirmPassword) {
                valid = false;
              }

              if (valid) {
                sessionStorage.setItem("newPassword", JSON.stringify(password));
                !sessionStorage.getItem("resetPasswordProcess") ? props.setPaso(9) : props.setPaso(11);
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function validate(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: "Ingresa tus credenciales"
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginPasswordStrength.LoginPasswordStrength, {
    emptyPassword: emptyPassword,
    emptyConfirmPassword: emptyConfirmPassword,
    matchPasswords: matchPasswords,
    textTittle: "Ingresa tus credenciales"
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "button-center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        return validate(e);
      }
    })
  }, "4")];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
      panelColor: _variables.GlobalColors.white,
      componentsArray: loginRight,
      panelType: "home-login"
    })
  });
};

exports.ChangePassword = ChangePassword;